import { Modal } from "./Modal";

type Props<T> = {
  formData: T & { resume?: File };
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => void;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
  isSubmitting: boolean;
};

export function BuildModal({
  formData,
  onChange,
  onClose,
  onSubmit,
  isSubmitting,
}: Props<{
  first_name: string;
  last_name: string;
  email: string;
  specialty: string;
  linkedin: string;
}>) {
  return (
    <Modal title="Help Build Mivalta" onClose={onClose}>
      <p className="mb-4">
        We’re looking for developers, designers, and privacy-first creators to
        help us build something Big Tech can’t.
      </p>
      <form className="flex flex-col gap-4" onSubmit={onSubmit}>
        {/* First Name */}
        <div className="flex flex-col">
          <input
            name="first_name"
            placeholder="First Name"
            value={formData.first_name}
            onChange={onChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-md bg-white text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-black"
            required
          />
        </div>

        {/* Last Name */}
        <div className="flex flex-col">
          <input
            name="last_name"
            placeholder="Last Name"
            value={formData.last_name}
            onChange={onChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-md bg-white text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-black"
            required
          />
        </div>

        {/* Email */}
        <div className="flex flex-col">
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={onChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-md bg-white text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-black"
            required
          />
        </div>

        {/* Specialty with helper text */}
        <div className="flex flex-col">
          <input
            name="specialty"
            placeholder="Specialty"
            value={formData.specialty}
            onChange={onChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-md bg-white text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-black"
            required
          />
          <span className="mt-1 text-xs text-gray-500">
            E.g. Backend, Frontend, Designer, etc.
          </span>
        </div>

        {/* LinkedIn */}
        <div className="flex flex-col">
          <input
            name="linkedin"
            placeholder="LinkedIn Profile"
            value={formData.linkedin}
            onChange={onChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-md bg-white text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-black"
          />
        </div>

        {/* Upload CV */}
        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700 mb-1">
            Upload CV
          </label>
          <input
            type="file"
            name="cv_file"
            accept=".pdf,.doc,.docx"
            onChange={onChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-md bg-white text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-black"
          />
          <span className="mt-1 text-xs text-gray-500">
            Accepted formats: PDF, DOC, DOCX
          </span>
        </div>

        {/* Action buttons */}
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm bg-gray-200 text-gray-800 rounded hover:bg-gray-300 transition"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={isSubmitting}
            className={`px-4 py-2 text-sm bg-[#23c8a1] text-white rounded hover:brightness-110 transition ${
              isSubmitting ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </div>
      </form>
    </Modal>
  );
}
